import { motion } from "framer-motion";
import { Eyebrow } from "@/components/form";

export function PageHero({ eyebrow, title, subtitle, image }) {
  const bg = image || "/ju-stairway.webp";
  return (
    <section className="relative overflow-hidden text-ivory grain">
      {/* imagery */}
      <div className="absolute inset-0">
        <img src={bg} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-900/95 via-navy/75 to-navy/25" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-transparent" />
      </div>

      {/* warm golden + emerald glows for life */}
      <div className="pointer-events-none absolute -top-24 right-[6%] h-80 w-80 rounded-full bg-gold/30 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-28 left-[15%] h-80 w-80 rounded-full bg-emerald/30 blur-3xl" />

      {/* drifting light shaft */}
      <motion.div
        className="pointer-events-none absolute -top-1/4 right-1/3 h-[150%] w-44 rotate-12 bg-gradient-to-b from-gold/25 via-gold/10 to-transparent blur-2xl"
        animate={{ opacity: [0.25, 0.6, 0.25], x: [0, 24, 0] }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* floating lion crest */}
      <motion.img
        src="/lion-logo.webp" alt=""
        className="pointer-events-none absolute right-4 lg:right-16 top-1/2 -translate-y-1/2 w-36 sm:w-48 lg:w-72 opacity-25 lg:opacity-40 drop-shadow-[0_20px_40px_rgba(197,160,89,0.35)]"
        animate={{ y: [-10, 10, -10], rotate: [-1.5, 1.5, -1.5] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8 py-24 lg:py-36">
        <motion.div
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }} className="max-w-3xl"
        >
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          <div className="mt-4 h-1 w-20 rounded-full bg-gradient-to-r from-gold via-gold/60 to-transparent" />
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.06] tracking-tight drop-shadow-[0_8px_24px_rgba(10,20,40,0.55)]">
            {title}
          </h1>
          {subtitle && <p className="mt-6 text-base sm:text-lg text-ivory/90 leading-relaxed drop-shadow-[0_4px_14px_rgba(10,20,40,0.5)]">{subtitle}</p>}
        </motion.div>
      </div>

      {/* golden bottom edge */}
      <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-transparent via-gold to-transparent" />
    </section>
  );
}
